import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import { useAuth } from '../context/AuthContext';
import '../styles/dashboard.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://unilinkapi-production.up.railway.app';

/** Redirects the logged-in student to their own registration edit page. */
export default function MyRegistration() {
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    const go = async () => {
      if (!user?.id) {
        setError('Unable to find your student profile.');
        return;
      }
      try {
        const res = await fetch(`${API_URL}/portal/me`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        const data = await res.json();
        if (cancelled) return;
        if (data.success && data.student?.id) {
          navigate(`/edit-student/${data.student.id}`, { replace: true });
        } else {
          navigate(`/edit-student/${user.id}`, { replace: true });
        }
      } catch {
        if (!cancelled) navigate(`/edit-student/${user.id}`, { replace: true });
      }
    };
    go();
    return () => { cancelled = true; };
  }, [user, token, navigate]);

  return (
    <>
      <Sidebar />
      <div className="main-content" id="mainContent">
        <Header />
        <div className="dashboard-container" style={{ padding: '40px 24px' }}>
          <p style={{ color: '#6b7280' }}>{error || 'Opening your registration form…'}</p>
        </div>
      </div>
    </>
  );
}
